import {
  GitRemoteApi,
  GitRemoteRefsRequest,
} from 'osep-generator-service-client-v1';
import { GIT_REMOTE_REF_KEY } from '../../utils/consts';
import { useApiConfig } from '../useApiConfig';
import { useQuery } from '@tanstack/react-query';

function useSearchGitRemoteRefQuery(gitRemoteRef: GitRemoteRefsRequest) {
  const { getApiConfig, axiosInstance } = useApiConfig();
  const request = {
    ...gitRemoteRef,
    repoUrl: gitRemoteRef.repoUrl?.trim() ?? '',
  };

  return useQuery({
    queryKey: [GIT_REMOTE_REF_KEY, request],
    queryFn: async () => {
      const config = await getApiConfig();
      const api = new GitRemoteApi(config, undefined, axiosInstance);

      const result = (await api.searchGitRemotesRefs(request)).data;

      return result;
    },
  });
}

export default useSearchGitRemoteRefQuery;
